import { providerLabel } from './textUtils';

const REFUND_LOCATIONS: Record<string, string> = {
  checkout_champ: 'in CheckoutChamp',
  shopify: 'in the Shopify admin',
};

// The alert network was already told the customer was refunded and that outcome is final, so the
// operator has to complete the refund at the processor by hand and then close the alert here.
export function refundUnsettledWarning(alertNetwork: string, ppType: string | null | undefined): string {
  const location = ppType ? REFUND_LOCATIONS[ppType] : undefined;
  const provider = ppType && location ? providerLabel(ppType) : 'the payment processor';

  return `This alert was already resolved with ${alertNetwork} as Refunded, but the refund was never confirmed at ${provider} `
    + `- see the Activity Log below for the transaction and decline reason. The ${alertNetwork} outcome can no longer be changed: `
    + `refund the customer ${location ?? 'at the payment processor'}, then resolve this alert to close it.`;
}
